import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { UpdateDiscountVerificationInput } from '@erp/rpc';

/**
 * Hook to update the verification status of a customer-specific discount
 * on a line item within a staged purchase order.
 *
 * Used by:
 * - Analysts clicking "Waive" in the UI (sets status to WAIVED)
 * - AI agent setting VERIFICATION_REQUESTED or VERIFIED
 */
export function useUpdateDiscountVerification() {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.accountsReceivable.salesOrderDrafts.updateDiscountVerification.mutationOptions(),
    onSuccess: (_data, variables) => {
      // Invalidate the discount validation query to refetch updated data
      queryClient.invalidateQueries({
        queryKey:
          orpc.accountsReceivable.salesOrderDrafts.validateDiscounts.queryOptions(
            {
              input: {
                stagedPurchaseOrderId: variables.stagedPurchaseOrderId,
              },
            },
          ).queryKey,
      });
    },
  });
}

export type { UpdateDiscountVerificationInput };
